import React from 'react';
import PageHeader from '../components/ui/PageHeader';

const LegalPage = ({ title, lastUpdated, content }) => {
  return (
    <div className="min-h-screen bg-royal-navy">
      <PageHeader title={title} />
      
      <section className="py-20 px-6 max-w-4xl mx-auto">
        <div className="bg-[#1A1F29]/40 backdrop-blur-md border border-white/5 rounded-2xl p-8 md:p-12 shadow-2xl">
          <p className="text-electric-green text-sm font-bold uppercase tracking-widest mb-8">
            Last Updated: {lastUpdated}
          </p>
          
          {/* Prose class handles all the spacing and typography for large text blocks */}
          <div className="prose prose-invert prose-green max-w-none text-gray-300">
            {content}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;